module.exports = __webpack_public_path__ + "img/OdontogramNew.78e3f845.svg";